export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.directive('nuxtClickAway', {
      mounted(el, binding) {
        el.clickOutSide = (evt) => {
          evt.stopPropagation();
          const lastMouseDownWasOutside = !el.contains(evt.target);
          if (lastMouseDownWasOutside) {
            binding.value.call();
          }
        };

        document.addEventListener('mousedown', el.clickOutSide);
      },
      unmounted(el) {
        document.removeEventListener('mousedown', el.clickOutSide);
      },
    });
  },
});
